/**
 * Redux action type constants for the session store.
 *
 * These live in appV2 so that both legacy `src/modules/session.ts` and the
 * Cognito-first `initCognitoSession.ts` can import them without creating
 * a transitive dependency chain that pulls moment-timezone and other heavy
 * legacy modules into the v2 typecheck scope.
 */
export const LOGIN_REQUESTED = "session/LOGIN_REQUESTED";
export const LOGIN_FAILURE = "session/LOGIN_FAILURE";
export const LOGIN_SUCCESS = "session/LOGIN_SUCCESS";
export const REGISTER_FAILURE = "session/REGISTER_FAILURE";
export const UPDATE_PROFILE = "session/UPDATE_PROFILE";
export const LOGOUT = "session/LOGOUT";
export const LOCATION_AGENTS_SUCCESS = "session/LOCATION_AGENTS_SUCCESS";
export const UPDATE_FLAG = "session/UPDATE_FLAG";
export const REACTIVATE_ACCOUNT = "session/REACTIVATE_ACCOUNT";
export const ADMIN_PROFILE = "session/ADMIN_PROFILE";
export const ADMIN_PROFILE_SUCCESS = "session/ADMIN_PROFILE_SUCCESS";
export const FIREBASE_LOGIN_SUCCESS = "FIREBASE_LOGIN_SUCCESS";
export const FIREBASE_LOGOUT = "FIREBASE_LOGOUT";
export const UPDATE_DRAWER = "UPDATE_DRAWER";
export const ADMIN_SESSION_TYPE = "ADMIN";
export const FIREBASE_TOKEN_READY = "FIREBASE_TOKEN_READY";
export const OPEN_SHIFT_CONFIRMATION = "OPEN_SHIFT_CONFIRMATION";
export const SET_BOOKING_ROLLOUT_MSAS = "SET_BOOKING_ROLLOUT_MSAS";
export const HCPS_WITH_PENDING_DOCS = "HCPS_WITH_PENDING_DOCS";
export const LD_PROFILE_IDENTIFIED = "session/LD_PROFILE_IDENTIFIED";
